module.exports = __webpack_public_path__ + "static/img/article_2x.a8f21f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rehabitation/article_2x.png
// module id = PsFJ
// module chunks = 1